<template>
  <div class="w-full p-6 bg-gray-50 min-h-screen">

     <!-- Selection Screen -->
     <div v-if="!marketType" class="flex items-center justify-center" style="height: 70vh;">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-8 text-center">
        
        <!-- Normal Charges Box -->
        <div @click="handleChargeTypeChange('marketplace')" class="group w-80 p-8 bg-white rounded-2xl shadow-lg hover:shadow-2xl border-2 border-transparent hover:border-primary transition-all duration-300 transform hover:-translate-y-2 cursor-pointer flex flex-col items-center justify-center">
          <Icon icon="mdi-upload" class="text-6xl mb-4 text-primary transition-transform duration-300 group-hover:scale-110" />
          <h2 class="text-2xl font-bold text-gray-700 mb-2 group-hover:text-primary transition-colors duration-300">Mettre en Ligne</h2>
          <p class="text-gray-500 text-sm">Mettre votre produit dans marketplace.</p>
        </div>

        <!-- Marketplace Charges Box -->
        <div @click="handleChargeTypeChange('retirer')" class="group w-80 p-8 bg-white rounded-2xl shadow-lg hover:shadow-2xl border-2 border-transparent hover:border-green-500 transition-all duration-300 transform hover:-translate-y-2 cursor-pointer flex flex-col items-center justify-center">
          <Icon icon="mdi-trash-can-outline" class="text-6xl mb-4 text-red-500 transition-transform duration-300 group-hover:scale-110" />
          <h2 class="text-2xl font-bold text-gray-700 mb-2 group-hover:text-green-500 transition-colors duration-300">Retirer un produit</h2>
          <p class="text-gray-500 text-sm">Retirer un produit déjà publié de la marketplace.</p>
        </div>

      </div>
    </div>

    <div v-else>
      <div class="mb-4">
        <button @click="resetFilter" class="flex items-center px-4 py-2 bg-white border border-gray-300 rounded-lg shadow-sm hover:bg-gray-50 text-sm font-medium text-gray-700 transition-colors">
          <Icon icon="mdi:arrow-left" class="mr-2" />
          Changer le type
        </button>
      </div>

    <div-table
      :config="filteredConfigList"
      :data="charges"
      :idWharhouse="idWharhouse"
      :currentUser="currentUser"
      :limit="limit"
      @reset="reset"
      @refresh="refresh"
      @filtrer="filtrer"
      @search="search"
      :loading="loading"
      :paginate="paginate"
      @paginatation="paginatation"
      @Changelimit="Changelimit"
    ></div-table>
  </div>
</div>
</template>

<script>
import config from "./configProducts";
import cloneDeep from 'lodash/cloneDeep';
export default {
  props: {
    currentUser: { type: Object },
    idWharhouse: { type: Object },
  },
  data() {
    return {
      marketType: null,
      filteredConfigList: null,  
      configList: config.list,
      loading: false,
      formData: {},
      charges: [],
      sellers: [],
      tabId: [],
      limit: 10,
      filters: {},
      paginate: {
        total: 0,
        currentpage: 1,
        lastpage: 0,
        per_page: 0,
      },
    };
  },
  computed: {
    warhouseSelected() {
      return this.$store.getters["wharhouse/warhouseSelected"]({
        user: _.pick(this.currentUser, ["countries"]),
      });
    },
  },
  watch: {
    warhouseSelected: async function (oldVal, newVal) {},
    idWharhouse: async function (oldVal, newVal) {
      this.idWharhouse = oldVal;
      await this.reset();
    },
    marketType: {
      immediate: true,
      handler(newValue) {
        // 1. تحديث config
        this.updateFilteredConfigList();

        // 2. تحديث البيانات
        this.filters = { limit: this.limit,type:'marketplace' };

        if (newValue) {
          this.getAvoirs(this.filters);
        } else {
          this.charges = [];
          this.paginate = { total: 0, currentpage: 1, lastpage: 1, per_page: 0 };
        }
    }
  },
  },
  created() {
  this.updateFilteredConfigList(); 
 },
  async mounted() {
    const savedFilters = this.$f.QueryStringToobject();
    console.log("Saved Filters on Mount:", savedFilters);
    if (savedFilters) {
      //if (this.filters['typeMarket']) this.marketType = this.filters['typeMarket'];
      if (this.filters['type']) this.marketType = this.filters['type'];
      if(!savedFilters.type) this.marketType = null;
    }else this.marketType = null;

    console.log("this.marketType Mount:", this.marketType);

    this.setDataSelect("status", ["pending", "approved", "rejected"], null);
    this.setDataSelect("category", this.$f.defaultCategories(), null);
    this.setDataSelect("warehouse", this.currentUser.countries, null);

    if (this.currentUser.type === "Seller") {
      let pos = this.configList.columns.map(function (e) {return e.name;}).indexOf("Seller");
      if (pos != -1) this.configList.columns.splice(pos, 1);
    }

    if (this.currentUser.type !== "Seller") await this.getSellers();
    this.setDataSelect("seller", this.sellers, null);
  },
  methods: {
     async resetFilter() {
      this.marketType = null
      this.charges = [];
      this.paginate = { total: 0, currentpage: 1, lastpage: 1, per_page: 0 };
      this.filters = {}
      this.$f.objectToQueryString({});
    },
     handleChargeTypeChange(type) {
      this.marketType = type;
      console.log("Selected Market Type:", this.marketType);
      if(type === 'retirer'){
        delete this.filters['typeMarket'];
        this.$f.objectToQueryString(this.filters);
      }
     // this.updateFilteredConfigList()
    },
    updateFilteredConfigList() {
      const cloned = cloneDeep(this.configList);
      const champs = cloned.filters.elements.champs || [];

     // cloned.filters.elements.champs = this.marketType === 'marketplace' ? champs.filter(c => c.key !== 'type') : champs;

      const champsColumn = cloned.columns || [];
      const targetIndex = champsColumn.findIndex(c => c.name.toLowerCase() === 'status');
      

      if (targetIndex !== -1 && this.marketType === 'retirer') {
        this.$set(champsColumn[targetIndex], 'name', 'Status Demande');
      }

      cloned.columns = this.marketType === 'marketplace' ? champsColumn.filter(c => c.name !== 'status rejection') : champsColumn;

      if(this.marketType === 'retirer'){
        cloned.title = 'Liste des demandes rejetées';
        cloned.buttonMettre = false

        const statusColumn = cloned.columns.find(col => col.name.toLowerCase() === "status demande");
        if (statusColumn && Array.isArray(statusColumn.elements)) {
          statusColumn.elements.forEach(element => {
            if (Array.isArray(element.items)) {
              element.items.forEach(item => {
                if (item.name === "status") {
                  item.disabled = true;
                }
              });
            }
          });
        }
      } 

      this.filteredConfigList = cloned;
    },
    async getwharhouseId() {
      await this.$store
        .dispatch("wharhouse/getwharhouseId", {
          country: this.warhouseSelected,
        })
        .then((res) => {
          this.idWharhouse = res;
        });
    },
    setDataSelect(model, data, splice) {
      for (var i = 0; i < this.configList.filters.elements.champs.length; i++) {
        if (
          this.configList.filters.elements.champs[i].type === "select" &&
          this.configList.filters.elements.champs[i].key === model
        ) {
          if (!splice) {
            this.configList.filters.elements.champs[i].values = data;
          } else {
            this.configList.filters.elements.champs.splice(i, 1);
          }
        }
      }
    },
    async getSellers() {
      const filter = {
        type: "Seller",
        countries: this.idWharhouse.country,
        limit: 10,
      };
      if (this.currentUser.type != "Seller") {
        const res = await this.$server.search("users", filter);
        if (res.content.results) this.sellers = res.content.results;
        else this.sellers = [];
      }
    },
    async Changelimit(val) {
      if (this.$f.QueryStringToobject())
        this.filters = this.$f.QueryStringToobject();
      this.filters["limit"] = val;
      this.filters["page"] = 1;
      this.paginate.currentpage = 1;
      this.$f.objectToQueryString(this.filters);
      if (this.filters.name) await this.search(this.filters.name);
      else this.getAvoirs(this.filters);
    },
    async filtrer(data) {
      if (this.$f.QueryStringToobject())
        this.filters = this.$f.QueryStringToobject();
      delete this.filters.page;
      delete this.filters.name;

      console.log("filter search________", data);
      this.paginate.currentpage = 1;
      if (!this.filters["limit"]) this.filters["limit"] = this.limit;
      if (data.seller) {
        this.filters["seller._id"] = data.seller._id;
      } else delete this.filters["seller._id"];
      if (data.status) {
       if(this.marketType === 'retirer') this.filters['rejection.status'] = data.status;
       else  this.filters.status = data.status;
      } else{
        delete this.filters.status;
        delete this.filters['rejection.status'];
      } 
      if (data.Range_date && data.Range_date[0]) {
        this.filters.Range_date = data.Range_date.map((el) =>
          this.$moment(el).format("yyyy-MM-DD")
        );
      } else delete this.filters.Range_date;
      if (data.warehouse) {
        this.filters["productObject.countries"] = data.warehouse.code;
      } else delete this.filters["productObject.countries"];
      if (data.category) {
        this.filters["productObject.category"] = data.category;
      } else delete this.filters["productObject.category"];
      this.$f.objectToQueryString(this.filters);
      await this.getAvoirs(this.filters);
    },
    async reset() {
      let lmitt = this.limit;
      if (this.$f.QueryStringToobject())
        this.filters = this.$f.QueryStringToobject();
      if (this.filters["limit"]) lmitt = this.filters["limit"];
      this.filters["page"] = 1;

      const savedFilters = this.$f.QueryStringToobject();
      if (savedFilters) {
       // if (this.filters['typeMarket']) this.marketType = this.filters['typeMarket'];
        if (this.filters['type']) this.marketType = this.filters['type'];
      }

      this.filters = _.pick(this.filters, ['type','typeMarket'])

      this.$f.objectToQueryString(this.filters);
      await this.getAvoirs(this.filters);
    },
    async refresh() {
      if (this.$f.QueryStringToobject()){
        this.filters = this.$f.QueryStringToobject();
       // if (this.filters['typeMarket']) this.marketType = this.filters['typeMarket'];
        if (this.filters['type']) this.marketType = this.filters['type'];
      } 
      this.$f.objectToQueryString(this.filters);


      if (this.filters.name) await this.search(this.filters.name);
      else await this.getAvoirs(this.filters);
      if (
        this.filters["page"] &&
        this.filters["page"] > 1 &&
        this.charges.length == 0
      ) {
        this.filters["page"] = --this.filters["page"];
        this.$f.objectToQueryString(this.filters);
        await this.getAvoirs(this.filters);
      }
    },
    async getAvoirs(filters) {
      if (!this.marketType) return this.$toast.warning('Une erreur est survenue, veuillez actualiser la page.');

      if (this.marketType === 'retirer') {
        this.filters.type = 'retirer';
      } else  {
        // Show normal charges, let filter bar specify further
        this.filters.type = 'marketplace';
      }

      if(this.marketType !== this.filters.type) return this.$toast.warning('Une erreur est survenue, veuillez actualiser la page.');


      this.$f.objectToQueryString(this.filters);

     // filters.type='marketplace';
      this.loading = true;
      const res = await this.$server.search("marketplaces", filters);
      this.loading = false;
      if (res && res.content.results) {
        this.charges = res.content.results;
        this.charges.forEach(
          function (offre) {
            offre.oldStatus = offre.status;
            if(this.marketType === 'retirer'){
              offre.statusRejection = offre.rejection.status;
            }
          }.bind(this)
        );

        this.paginate.total = res.content.total;
        this.paginate.lastpage = res.content.last_page;
        this.paginate.per_page = res.content.per_page;
        this.paginate.currentpage = res.content.current_page;
      } else {
        this.charges = [];
        this.paginate = { total: 0, currentpage: 1, lastpage: 1, per_page: 0 };
      }
    },
    async search(data) {
      this.paginate = { total: 0, currentpage: 1, lastpage: 1, per_page: 0 };
      let limitt = this.limit;
      if (this.filters["limit"]) limitt = this.filters["limit"];
      const search = {
        name: data.trim(),
        type: 'marketplace',
        limit: parseInt(limitt),
      };

      if (this.marketType === 'retirer') {
        search.type = 'retirer';
      } else {
        search['type'] = 'marketplace';
      }

      this.$f.objectToQueryString(search);
      const res = await this.$server.find("marketplaces", search);
      if (res.content.results) {
        this.charges = res.content.results;
        this.charges.forEach(
          function (offre) {
            offre.oldStatus = offre.status;
             if(this.marketType === 'retirer'){
              offre.statusRejection = offre.rejection.status;
            }
          }.bind(this)
        );
        this.paginate.total = res.content.total;
        this.paginate.lastpage = res.content.last_page;
        this.paginate.per_page = res.content.per_page;
        this.paginate.currentpage = res.content.current_page;
      } else {
        this.charges = [];
        this.paginate = { total: 0, currentpage: 1, lastpage: 1, per_page: 0 };
      }
    },
    async remove(id) {
      this.$confirm("You want to delete this marketplace?").then(
        async (res) => {
          if (res) {
            const resp = await this.$server.delete("marketplaces", { id: id });
            await this.refresh();
            alert("marketplace Deleted", "success");
          }
        }
      );
    },
    async paginatation(direction) {
      let page = 0;

      if (
        direction === "next" &&
        this.paginate.currentpage < this.paginate.lastpage
      ) {
        page = ++this.paginate.currentpage;
      } else if (direction === "prev" && this.paginate.currentpage > 1) {
        page = --this.paginate.currentpage;
      } else if (
        direction.type === "goto" &&
        direction.page >= 1 &&
        direction.page <= this.paginate.lastpage
      ) {
        page = this.paginate.currentpage = direction.page;
      }

      if (this.$f.QueryStringToobject()) {
        this.filters = this.$f.QueryStringToobject();
      }

      this.filters["page"] = page;
      this.$f.objectToQueryString(this.filters);

      this.getAvoirs(this.filters);
    },
  },
};
</script>

<style scoped>
.crancy-hbanner {
  background-color: #194bfb;
  border-radius: 12px;
  padding-right: 40px;
  padding-left: 40px;
  display: flex;
  justify-content: space-between;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  min-height: 250px;
  align-items: center;
}

.crancy-hbanner__content {
  max-width: 65%;
  margin-top: -6px;
}

.crancy-hbanner__title {
  font-size: 40px;
  color: #fff;
  font-weight: 700;
}

.crancy-hbanner__text {
  font-size: 16px;
  color: #fff;
  font-weight: 400;
}
</style>
